export const KEYBOARD_KEY = {
  ESCAPE: 'Escape',
  ENTER: 'Enter'
};